import {createScriptIn} from './ui_utils/DomUtils'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {ClientUserState} from './ClientUserState'

export class GoogleOneTapLoader {
    private static initialized = false
    static init() {
        if(ClientUserState.userState?.isLoggedIn) {
            document.getElementById('g_id_onload')?.setAttribute('data-auto_prompt', 'false')
            this.cancelPopup()
            this.delayedCancelPopup()
        } else {
            document.getElementById('g_id_onload')?.setAttribute('data-auto_prompt', 'true')
        }

        if(this.initialized) return

        if(UIUtilsEjsVariables.isUserOnMobile) return
        if(UIUtilsEjsVariables.isUserOnDiscord) return
        if(ClientUserState.userState?.isLoggedIn) return

        createScriptIn(document.body, 'https://accounts.google.com/gsi/client')
        this.initialized = true
    }

    private static cancelPopup() {
        // @ts-expect-error window.google unknown
        window.google?.accounts?.id?.cancel()
    }

    private static delayedCancelPopup() {
        if(!this.initialized) return

        for(let timeout = 0; timeout < 2_000; timeout += 500) {
            setTimeout(() => {
                this.cancelPopup()
            }, timeout)
        }
    }
}
